import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16_9684)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 11.2264L14.2736 16L15 15.2736L10.2264 10.5L15 5.72645L14.2736 5L9.5 9.77355L4.72645 5L4 5.72645L8.77355 10.5L4 15.2736L4.72645 16L9.5 11.2264Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_16_9684">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;
